import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Plus, Save, Trash2 } from "lucide-react";
import { Card, Btn, Input } from "@/components/admin/ui";
import { API } from "@/config";

export const Categories = () => {
  const [cats, setCats] = useState([]);
  const [newName, setNewName] = useState("");
  const load = useCallback(() => axios.get(`${API}/admin/categories`).then(r => setCats(r.data.categories)), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    if (!newName.trim()) return;
    await axios.post(`${API}/admin/categories`, { name: newName, order: cats.length + 1, subcategories: [] });
    setNewName(""); load();
  };
  const save = async (id, updates) => { await axios.patch(`${API}/admin/categories/${id}`, updates); load(); };
  const del = async (id) => { if (window.confirm("Delete this category?")) { await axios.delete(`${API}/admin/categories/${id}`); load(); } };
  return (
    <div>
      <h1 className="font-serif text-4xl mb-6">Categories</h1>
      <Card className="p-5 mb-4 flex gap-3 items-end">
        <div className="flex-1"><label className="text-xs uppercase tracking-[0.2em] text-[#B9C8D5]">New category name</label><Input value={newName} onChange={e => setNewName(e.target.value)} placeholder="e.g. Sleep, Feeding, Play" data-testid="cat-new-name" /></div>
        <Btn onClick={add} data-testid="cat-add-btn"><Plus className="w-3.5 h-3.5" /> Add</Btn>
      </Card>
      <div className="space-y-3">
        {cats.map(c => <CategoryRow key={c.id} c={c} onSave={u => save(c.id, u)} onDelete={() => del(c.id)} />)}
      </div>
    </div>
  );
};

const CategoryRow = ({ c, onSave, onDelete }) => {
  const [f, setF] = useState({ name: c.name, order: c.order, subs: (c.subcategories || []).join(", ") });
  return (
    <Card className="p-5" data-testid={`cat-row-${c.id}`}>
      <div className="grid md:grid-cols-[1fr_1fr_auto_auto] gap-3 items-center">
        <Input value={f.name} onChange={e => setF({ ...f, name: e.target.value })} />
        <Input value={f.subs} onChange={e => setF({ ...f, subs: e.target.value })} placeholder="Subcategories (comma-separated)" />
        <Input type="number" value={f.order} onChange={e => setF({ ...f, order: e.target.value })} className="w-20" />
        <div className="flex gap-2">
          <Btn onClick={() => onSave({ name: f.name, order: Number(f.order), subcategories: f.subs.split(",").map(s => s.trim()).filter(Boolean) })} data-testid={`cat-save-${c.id}`}><Save className="w-3.5 h-3.5" /></Btn>
          <Btn variant="danger" onClick={onDelete}><Trash2 className="w-3.5 h-3.5" /></Btn>
        </div>
      </div>
    </Card>
  );
};
